<template>
    <div class="our-calculations"
         v-if="myResources.text">
        <p v-for="(paragraph, index) in myResources.text"
           :key="index">
            {{ paragraph }}
        </p>
    </div>
</template>
<script>

import ResourcesHelper from '@/components/resources-helper'

export default {
    mixins: [
        ResourcesHelper,
    ],

    computed: {
        /**
         * @returns {CopyOurCalculationsResources}
         */
        myResources() {
            return this.parseResources('components.copy.ourCalculations')
        },
    },
}

</script>
